import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleI18nSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { resendLink } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const i18nSelector = makeModuleI18nSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const i18n = i18nSelector(state, props);

    return {
      ...props,
      hint: i18n.infoResetPasswordExpired,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  resend: () => dispatch(resendLink(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
